import styled from 'styled-components';
import { rem } from '@/styles/theme';

interface IProps {
  emphasis?: string | null;
}

export const Wrapper = styled.div`
  display: flex;
  padding: ${rem(10)} ${rem(18)};
  gap: ${rem(14)};
  ${({ theme }) => theme.media.fold`
    padding: ${rem(8)} ${rem(20)};
    gap: ${rem(12)};
  `}
`;

export const RightArea = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const TitleArea = styled.div`
  gap: ${rem(2)};
  display: flex;
  flex-direction: column;
`;

export const TextMiddleArea = styled.div<IProps>`
  display: flex;
  flex-direction: row;
  margin-bottom: ${rem(10)};
  ${({ emphasis }) =>
    emphasis
      ? `
            flex-direction: column;
            margin-top: ${rem(10)};
            margin-bottom: ${rem(18)};
          `
      : `
            justify-content: space-between;
            margin-top: ${rem(8.5)};
            margin-bottom: ${rem(16.5)};
          `};
  ${({ emphasis, theme }) =>
    emphasis
      ? theme.media.fold`
      margin-top: ${rem(10)};
      margin-bottom: ${rem(16)};
  `
      : theme.media.fold`
      margin-top: ${rem(8)};
      margin-bottom: ${rem(14)};
  `}
`;

export const Label = styled.div`
  display: flex;
  gap: ${rem(4)};
  align-items: center;
`;

export const LabelArea = styled.div<IProps>`
  display: flex;
  flex-wrap: wrap;
  gap: ${rem(12)};
  ${({ emphasis, theme }) =>
    emphasis
      ? theme.media.fold`
      margin-bottom: ${rem(10)};
    `
      : theme.media.fold`
      flex-direction: column;
      gap: ${rem(2)};
    `}
`;

export const BottomArea = styled.div<IProps>`
   ${({ emphasis }) => emphasis && `margin-top: ${rem(10)};`}
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
